var map = {
	"./choose_1_1.png": "6X+4",
	"./choose_2_1.png": "MG4F"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "yuIk";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/choose_.*_1\.png$
// module id = yuIk
// module chunks = 0